import React from 'react'
import './_styles.scss'
import Translator from '../../../../../../../../../requests/apa/Translator'
import Utils from '../../../../../../../../../utils/Utils'

function CountryDetailsLeft ({ name, color, crestUrl, flagUrl, recentResults }) {
  return (
    <div className='country-details-header__left'>
      <div className='country-details-header__badge-outer' style={{ backgroundColor: color }}>
        <div className='country-details-header__badge-inner'>
          <img className='country-details-header__badge-img' src={crestUrl} alt={name || ''} />
        </div>
      </div>
      {flagUrl && (
        <div className='country-details-header__flag-wrapper'>
          <img className='country-details-header__flag' src={flagUrl} alt='' />
        </div>
      )}
      <div className='country-details-header__name-wrapper'>
        <p className='country-details-header__name'>{Utils.cutPlayerString(name, 15)}</p>
      </div>
      <div className='country-details-header__recent-section'>
        <div className='country-details-header__recent-label-wrapper'>
          <p className='country-details-header__recent-label'>{Translator.get('eventodeportivo_paises_texto_titulo_ultimospartidos')}</p>
        </div>
        <div className='country-details-header__recent-matches'>
          {
            recentResults && recentResults.map((match, index) => (
              <span key={index} className={`country-details-header__recent-matches-label country-details-header__recent-matches-label${match.matchStatusClassName}`}>{match.labelFromKey}</span>
            ))
          }
        </div>
      </div>
    </div>
  )
}

export default CountryDetailsLeft



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsHeader/Components/CountryDetailsLeft/index.jsx